export default "__VITE_ASSET__CJcsXke3__"